import type { Dispatch, SetStateAction } from "react";
import Users from "@Front/Api/LeCoffreApi/Notary/Users/Users";
import { clearNotaryContactEmailPromptDismissedInSession } from "./notaryMissingContactEmailSession";
import { validateEmail } from "@Front/Utils/formValidators";

export type PersistNotaryContactEmailResult = { ok: true } | { ok: false; reason: "invalid_email" | "request_failed" };

export async function persistNotaryContactEmail(
	emailRaw: string,
	refetchUser: () => Promise<void>,
	setOpen: Dispatch<SetStateAction<boolean>>,
	refreshPermissionContext?: () => Promise<void>,
): Promise<PersistNotaryContactEmailResult> {
	const v = validateEmail(emailRaw);
	if (!v.isValid) {
		return { ok: false, reason: "invalid_email" };
	}
	try {
		await Users.getInstance().putMyContactEmail(emailRaw.trim());
		await refetchUser();
		await refreshPermissionContext?.();
		setOpen(false);
		clearNotaryContactEmailPromptDismissedInSession();
		return { ok: true };
	} catch {
		return { ok: false, reason: "request_failed" };
	}
}
